import React from "react";
import "typeface-roboto";
import * as firebase from "firebase/app";
import "firebase/auth";
import withFirebaseAuth, {
  WrappedComponentProps,
} from "react-with-firebase-auth";
import { firebaseConfig } from "./config";
import ReportDashboard from "./Report/Dashboard";
import PaymentDashboard from "./Payment/Landing";
import Login from "./components/Login";

import { Direction, WhereToGo } from "./utils/direction";

const App = ({ signInWithGoogle, signOut, user }: WrappedComponentProps) => {
  if (user) {
    const direction = WhereToGo();

    if (direction === Direction.Dashboard) {
      console.log("going to report");
      return <ReportDashboard signOut={signOut} user={user} />;
    } else if (direction === Direction.Payment) {
      console.log("going to payment");
      // return <Dashboard signOut={signOut} user={user} />;
      return <PaymentDashboard signOut={signOut} user={user} />;
    } else {
      // TODO handle this
    }
  }

  return <Login signInWithGoogle={signInWithGoogle} />;
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const firebaseAppAuth = firebaseApp.auth();
const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
};

export default withFirebaseAuth({
  providers,
  firebaseAppAuth,
})(App);
